import HybridElectricLandingPage from '@src/components/city/HybridElectricLandingPage';
import VehicleLandingPage from '@src/components/city/VehicleLandingPage';
import * as geoLocationActions from '@src/redux/actions/geolocation';
import { fetchCritAndZip, setLocation } from '@src/utils/geolocation';
import { sanity } from '@src/utils/sanity';
//export const config = { amp: true }  --  TODO: NEED TO TEST AMP SETTINGS TO GET AMP - Current Error "The attribute 'href' in tag 'link rel=stylesheet for fonts' is set to the invalid value '/static/nprogress.css'""
import parsePhoneNumber from 'libphonenumber-js';
import { findPhoneNumbersInText } from 'libphonenumber-js';
import { NextSeo } from 'next-seo';
import React from 'react';
import { useSelector } from 'react-redux';

const Form = props => {
	const geolocation = props.geolocation;
	const masterProvider = useSelector(state => state.masterProvider);

	var phoneNumber = '(800)228-8379'; // TODO:  Move all Phone and Email to a Global Object Parsing ( )
	var googleNumber = '+18002288379';
	var emailAddress = 'info@1800battery.com';

	if (masterProvider && masterProvider.isActive) {
		phoneNumber = masterProvider.phoneNumber ? masterProvider.phoneNumber : '';
		emailAddress = masterProvider.emailAddress ? masterProvider.emailAddress : '';
	}

	googleNumber = findPhoneNumbersInText(phoneNumber, 'US');
	if (googleNumber.length > 0) {
		googleNumber = parsePhoneNumber(googleNumber[0].number.number);
		phoneNumber = googleNumber.formatNational();
		googleNumber = googleNumber.getURI();
	}

	var keywords = [];
	keywords.push((props.category ? props.category : 'Vehicle') + ' Battery');
	keywords.push(geolocation ? geolocation.formattedAddress : 'Your City');
	keywords.push('Same Day Delivery');
	keywords.push('Professional Installation');
	keywords.push('National Warranty');
	keywords.push('Near Me');

	var hostname = '1800battery.com';
	if (typeof window !== 'undefined') {
		hostname = window.location.hostname;
	}

	const url = props?.category || '';
	const isManual = false;
	const myHref = isManual ? `/${url}` : `/category/[categoryid]?categoryid=${url}`;
	const asVar = isManual ? url : `/category/${url}`;
	const canonical = `https://${hostname}/cities/${props.router.query.category}`;
	const target = url === 'vehicle-batteries-hybrid-electric' ? 'Hybrid Electric' : 'Car/Automotive';
	return (
		<>
			<NextSeo
				title={`${target} Battery Replacement & Install in ${
					geolocation?.formatted_address ? geolocation.formatted_address : 'Your City'
				}`}
				description={`1-800-Battery offers mobile ${target} battery replacement services in ${
					geolocation?.formatted_address ? geolocation.formatted_address : 'Your City'
				}. Make an appointment for your installation now.`}
				canonical={canonical}
				keywords={keywords.join()}
			/>

			{url === 'vehicle-batteries-hybrid-electric' ? (
				<HybridElectricLandingPage
					CMSData={props.CMSData.page}
					phoneNumber={phoneNumber}
					geolocation={geolocation}
					myHref={'/category/vehicle-batteries-hybrid-electric'}
					asVar={'/category/vehicle-batteries-hybrid-electric'}
					googleNumber={googleNumber}
				/>
			) : (
				<VehicleLandingPage
					CMSData={props.CMSData.page}
					phoneNumber={phoneNumber}
					geolocation={geolocation}
					myHref={'/category/vehicle-batteries-car-or-truck'}
					asVar={'/category/vehicle-batteries-car-or-truck'}
					googleNumber={googleNumber}
				/>
			)}
		</>
	);
};

Form.getInitialProps = async ctx => {
	const category = ctx.query.category;
	const crit = ctx.query.crit;
	let geo = null;
	if (ctx.store.getState().geolocation.latitude) {
		geo = ctx.store.getState().geolocation;
	} else {
		geo = await fetchCritAndZip(crit, true);
	}
	setLocation(geo);
	ctx.store.dispatch(geoLocationActions.setLocation(geo));

	const pageQuery = `*[_type == "landing" && slug.current == $slug] { slug, sections }`;
	const data = await sanity.fetch(pageQuery, { slug: category });
	return { CMSData: data, geolocation: geo, category: category };
};

export default Form;
